// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import iView from 'iview'
import store from './store'
import VueResource from 'vue-resource'
import axios from 'axios'
import 'babel-polyfill'
import 'url-search-params-polyfill'
import ElementUI from 'element-ui'
import $ from 'jquery'
import VueClipboard from 'vue-clipboard2'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import * as echarts from 'echarts';

import './assets/css/img-icon/iconfont.css'
import './assets/css/element-ui/index.css'
import './assets/css/iview/iview.css'
import './assets/css/index.scss'
import './assets/css/font-awesome/css/font-awesome.min.css'

//字符串过滤器
import "./util/filter.js"
//导航守卫
import "./router/router_guard"
//aixos拦截器
import "./util/api.js"

import JsonViewer from 'vue-json-viewer'

//公用方法
import Common from './util/common.js'
Vue.use(Common);

//引入Excel
import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'

// 封装公共方法,导出Excel******************************************************
Vue.prototype.ExportExcel = function(list,tHeader,filterVal){
  // 导出数据
  this.list = list
  // 表头数据
  this.tHeader = tHeader
  // 表头数据对应名字
  this.filterVal = filterVal
  // 数据方法
  this.formatJson = function(filterVal, jsonData){
    return jsonData.map(v => filterVal.map(j => v[j]))
  }
  // 导出文件的方法
  this.export2Excel = function(fileName){
　　require.ensure([], () => {
　　　　const { export_json_to_excel } = require('@/Excel/Export2Excel')
　　　　const tHeader = this.tHeader
　　　　const filterVal = this.filterVal
　　　　const list = this.list
　　　　const data = this.formatJson(filterVal, list)
　　　　export_json_to_excel(tHeader, data, fileName)
　　})    
  }
}

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.prototype.axios = axios;
Vue.prototype.$echarts = echarts;
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(iView);
Vue.use(VueClipboard)
Vue.use(JsonViewer)
 
new Vue({
  el: '#app',
  router,
	store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js